
  import React from "react"
  import Component from "/Users/shivekkhurana/Wip/archives/Speer/website/src/layouts/index.js"
  import data from "/Users/shivekkhurana/Wip/archives/Speer/website/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js